/**
 * Re-export of ContextEdit from ListingPageV2. Consumed by TravellerDetailsV2
 * so that it does not need to reach deep into the ListingPageV2 directory tree.
 */

export { ContextEdit } from "../../ListingPageV2/components/ContextEdit/ContextEdit";
